// extracted by mini-css-extract-plugin
export default {"wrap":"TF-z","fullWidth":"UF-z","hideOnDesktop":"VF-z","content":"WF-z","hasOpenedNav":"XF-z","crumbsList":"YF-z","dropdownsWrap":"ZF-z"};